import { teamIds } from './personalizationIds'

export const teamData = {
  'Arizona Diamondbacks': {
    id: teamIds['Arizona Diamondbacks'],
    logo: 'https://gn-imgx.fubo.tv/assets/t1_l_h15_ac.png',
    backgroundColor: '#000000',
    name: 'Arizona Diamondbacks',
    league: 'mlb',
  },
  Athletics: {
    id: teamIds['Athletics'],
    logo: 'https://gn-imgx.fubo.tv/assets/t76180_l_h15_aa.png',
    backgroundColor: '#ffb819',
    name: 'Athletics',
    league: 'mlb',
  },
  'Atlanta Braves': {
    id: teamIds['Atlanta Braves'],
    logo: 'https://imgx.fubo.tv/team_logos/braves.png',
    backgroundColor: '#13274f',
    name: 'Atlanta Braves',
    league: 'mlb',
  },
  'Baltimore Orioles': {
    id: teamIds['Baltimore Orioles'],
    logo: 'https://imgx.fubo.tv/team_logos/baltimore-orioles.png',
    backgroundColor: '#000000',
    name: 'Baltimore Orioles',
    league: 'mlb',
  },
  'Boston Red Sox': {
    id: teamIds['Boston Red Sox'],
    logo: 'https://imgx.fubo.tv/team_logos/t4_l_h5_aa.png',
    backgroundColor: '#0C2340',
    name: 'Boston Red Sox',
    league: 'mlb',
  },
  'Chicago Cubs': {
    id: teamIds['Chicago Cubs'],
    logo: 'https://gn-imgx.fubo.tv/assets/t5_l_h15_ad.png',
    backgroundColor: '#0f3385',
    name: 'Chicago Cubs',
    league: 'mlb',
  },
  'Chicago White Sox': {
    id: teamIds['White Sox'],
    logo: 'https://gn-imgx.fubo.tv/assets/t6_l_h15_af.png',
    backgroundColor: '#000000',
    name: 'Chicago White Sox',
    league: 'mlb',
  },
  'Cincinnati Reds': {
    id: teamIds['Cincinnati Reds'],
    logo: 'https://imgx.fubo.tv/team_logos/cincinnati-reds.png',
    backgroundColor: '#c6011f',
    name: 'Cincinnati Reds',
    league: 'mlb',
  },
  'Cleveland Guardians': {
    id: teamIds['Cleveland Guardians'],
    logo: 'https://gn-imgx.fubo.tv/assets/t23385_l_h15_ab.png',
    backgroundColor: '#cf152d',
    name: 'Cleveland Guardians',
    league: 'mlb',
  },
  'Colorado Rockies': {
    id: teamIds['Colorado Rockies'],
    logo: 'https://gn-imgx.fubo.tv/assets/t9_l_h15_ad.png',
    backgroundColor: '#33006f',
    name: 'Colorado Rockies',
    league: 'mlb',
  },
  'Detroit Tigers': {
    id: teamIds['Detroit Tigers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t10_l_h15_ac.png',
    backgroundColor: '#f26722',
    name: 'Detroit Tigers',
    league: 'mlb',
  },
  'Houston Astros': {
    id: teamIds['Houston Astros'],
    logo: 'https://imgx.fubo.tv/team_logos/houston-astros.png',
    backgroundColor: '#eb6e1f',
    name: 'Houston Astros',
    league: 'mlb',
  },
  'Kansas City Royals': {
    id: teamIds['Kansas City Royals'],
    logo: 'https://imgx.fubo.tv/team_logos/kansas-city-royals.png',
    backgroundColor: '#7bb2dd',
    name: 'Kansas City Royals',
    league: 'mlb',
  },
  'Los Angeles Angels': {
    id: teamIds['Los Angeles Angels'],
    logo: 'https://gn-imgx.fubo.tv/assets/t16396_l_h15_ad.png',
    backgroundColor: '#ba0021',
    name: 'Los Angeles Angels',
    league: 'mlb',
  },
  'Los Angeles Dodgers': {
    id: teamIds['Los Angeles Dodgers'],
    logo: 'https://imgx.fubo.tv/team_logos/dodgers.png',
    backgroundColor: '#b2b7bb',
    name: 'Los Angeles Dodgers',
    league: 'mlb',
  },
  'Miami Marlins': {
    id: teamIds['Miami Marlins'],
    logo: 'https://gn-imgx.fubo.tv/assets/t6075_l_h15_af.png',
    backgroundColor: '#00a3e0',
    name: 'Miami Marlins',
    league: 'mlb',
  },
  'Milwaukee Brewers': {
    id: teamIds['Milwaukee Brewers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t16_l_h15_ag.png',
    backgroundColor: '#12284b',
    name: 'Milwaukee Brewers',
    league: 'mlb',
  },
  'Minnesota Twins': {
    id: teamIds['Minnesota Twins'],
    logo: 'https://gn-imgx.fubo.tv/assets/t17_l_h15_ad.png',
    backgroundColor: '#002b5c',
    name: 'Minnesota Twins',
    league: 'mlb',
  },
  'New York Mets': {
    id: teamIds['New York Mets'],
    logo: 'https://imgx.fubo.tv/team_logos/new-york-mets.png',
    backgroundColor: '#002d72',
    name: 'New York Mets',
    league: 'mlb',
  },
  'New York Yankees': {
    id: teamIds['New York Yankees'],
    logo: 'https://imgx.fubo.tv/team_logos/New_York_Yankees_Primary_Logo.svg.png',
    backgroundColor: '#142448',
    name: 'New York Yankees',
    league: 'mlb',
  },
  'Philadelphia Phillies': {
    id: teamIds['Philadelphia Phillies'],
    logo: 'https://gn-imgx.fubo.tv/assets/t21_l_h15_ad.png',
    backgroundColor: '#e81828',
    name: 'Philadelphia Phillies',
    league: 'mlb',
  },
  'Pittsburgh Pirates': {
    id: teamIds['Pittsburgh Pirates'],
    logo: 'https://imgx.fubo.tv/team_logos/Pittsburgh_Pirates.png',
    backgroundColor: '#000000',
    name: 'Pittsburgh Pirates',
    league: 'mlb',
  },
  'San Diego Padres': {
    id: teamIds['San Diego Padres'],
    logo: 'https://imgx.fubo.tv/team_logos/SD_Padres.png',
    backgroundColor: '#2f241d',
    name: 'San Diego Padres',
    league: 'mlb',
  },
  'San Francisco Giants': {
    id: teamIds['San Francisco Giants'],
    logo: 'https://imgx.fubo.tv/team_logos/image21.png',
    backgroundColor: '#27251f',
    name: 'San Francisco Giants',
    league: 'mlb',
  },
  'Seattle Mariners': {
    id: teamIds['Seattle Mariners'],
    logo: 'https://imgx.fubo.tv/team_logos/Seattle_Mariners.png',
    backgroundColor: '#005c5c',
    name: 'Seattle Mariners',
    league: 'mlb',
  },
  'St. Louis Cardinals': {
    id: teamIds['St Louis Cardinals'],
    logo: 'https://gn-imgx.fubo.tv/assets/t26_l_h15_ac.png',
    backgroundColor: '#14264b',
    name: 'St. Louis Cardinals',
    league: 'mlb',
  },
  'Tampa Bay Rays': {
    id: teamIds['Tampa Bay Rays'],
    logo: 'https://imgx.fubo.tv/team_logos/Tampa_Bay_Rays.png',
    backgroundColor: '#79bee8',
    name: 'Tampa Bay Rays',
    league: 'mlb',
  },
  'Texas Rangers': {
    id: teamIds['Texas Rangers'],
    logo: 'https://imgx.fubo.tv/team_logos/T_WhiteRed.png',
    backgroundColor: '#003278',
    name: 'Texas Rangers',
    league: 'mlb',
  },
  'Toronto Blue Jays': {
    id: teamIds['Toronto Blue Jays'],
    logo: 'https://gn-imgx.fubo.tv/assets/t29_l_h15_ai.png',
    backgroundColor: '#134a8e',
    name: 'Toronto Blue Jays',
    league: 'mlb',
  },
  'Washington Nationals': {
    id: teamIds['Washington Nationals'],
    logo: 'https://imgx.fubo.tv/team_logos/washington-nationals.png',
    backgroundColor: '#14225a',
    name: 'Washington Nationals',
    league: 'mlb',
  },
  'Anaheim Ducks': {
    id: teamIds['Anaheim Ducks'],
    logo: 'https://gn-imgx.fubo.tv/assets/t430_l_h15_ad.png',
    backgroundColor: '#f47a38',
    name: 'Anaheim Ducks',
    league: 'nhl',
  },
  'Boston Bruins': {
    id: teamIds['Boston Bruins'],
    logo: 'https://gn-imgx.fubo.tv/assets/t432_l_h15_ae.png',
    backgroundColor: '#000000',
    name: 'Boston Bruins',
    league: 'nhl',
  },
  'Buffalo Sabres': {
    id: teamIds['Buffalo Sabres'],
    logo: 'https://gn-imgx.fubo.tv/assets/t433_l_h15_ae.png',
    backgroundColor: '#7D5B1C',
    name: 'Buffalo Sabres',
    league: 'nhl',
  },
  'Calgary Flames': {
    id: teamIds['Calgary Flames'],
    logo: 'https://gn-imgx.fubo.tv/assets/t434_l_h15_ac.png',
    backgroundColor: '#A40000',
    name: 'Calgary Flames',
    league: 'nhl',
  },
  'Carolina Hurricanes': {
    id: teamIds['Carolina Hurricanes'],
    logo: 'https://gn-imgx.fubo.tv/assets/t435_l_h15_ac.png',
    backgroundColor: '#cc0000',
    name: 'Carolina Hurricanes',
    league: 'nhl',
  },
  'Chicago Blackhawks': {
    id: teamIds['Chicago Blackhawks'],
    logo: 'https://gn-imgx.fubo.tv/assets/t436_l_h15_ac.png',
    backgroundColor: '#cf0a2c',
    name: 'Chicago Blackhawks',
    league: 'nhl',
  },
  'Colorado Avalanche': {
    id: teamIds['Colorado Avalanche'],
    logo: 'https://gn-imgx.fubo.tv/assets/t437_l_h15_ac.png',
    backgroundColor: '#63203D',
    name: 'Colorado Avalanche',
    league: 'nhl',
  },
  'Columbus Blue Jackets': {
    id: teamIds['Columbus Blue Jackets'],
    logo: 'https://gn-imgx.fubo.tv/assets/t438_l_h15_ac.png',
    backgroundColor: '#002654',
    name: 'Columbus Blue Jackets',
    league: 'nhl',
  },
  'Dallas Stars': {
    id: teamIds['Dallas Stars'],
    logo: 'https://imgx.fubo.tv/team_logos/DallasStars.png',
    backgroundColor: '#006341',
    name: 'Dallas Stars',
    league: 'nhl',
  },
  'Detroit Red Wings': {
    id: teamIds['Detroit Red Wings'],
    logo: 'https://gn-imgx.fubo.tv/assets/t440_l_h15_ac.png',
    backgroundColor: '#AF0000',
    name: 'Detroit Red Wings',
    league: 'nhl',
  },
  'Edmonton Oilers': {
    id: teamIds['Edmonton Oilers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t441_l_h15_af.png',
    backgroundColor: '#fc4c02',
    name: 'Edmonton Oilers',
    league: 'nhl',
  },
  'Florida Panthers': {
    id: teamIds['Florida Panthers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t442_l_h15_ba.png',
    backgroundColor: '#041e42',
    name: 'Florida Panthers',
    league: 'nhl',
  },
  'Los Angeles Kings': {
    id: teamIds['Los Angeles Kings'],
    logo: 'https://gn-imgx.fubo.tv/assets/t443_l_h9_ae.png',
    backgroundColor: '#a2aaad',
    name: 'Los Angeles Kings',
    league: 'nhl',
  },
  'Minnesota Wild': {
    id: teamIds['Minnesota Wild'],
    logo: 'https://gn-imgx.fubo.tv/assets/t444_l_h15_ad.png',
    backgroundColor: '#154734',
    name: 'Minnesota Wild',
    league: 'nhl',
  },
  'Montreal Canadiens': {
    id: teamIds['Montreal Canadiens'],
    logo: 'https://gn-imgx.fubo.tv/assets/t445_l_h15_ac.png',
    backgroundColor: '#192168',
    name: 'Montreal Canadiens',
    league: 'nhl',
  },
  'Nashville Predators': {
    id: teamIds['Nashville Predators'],
    logo: 'https://gn-imgx.fubo.tv/assets/t446_l_h15_ac.png',
    backgroundColor: '#ffb81c',
    name: 'Nashville Predators',
    league: 'nhl',
  },
  'New Jersey Devils': {
    id: teamIds['New Jersey Devils'],
    logo: 'https://gn-imgx.fubo.tv/assets/t447_l_h15_ac.png',
    backgroundColor: '#000000',
    name: 'New Jersey Devils',
    league: 'nhl',
  },
  'New York Islanders': {
    id: teamIds['New York Islanders'],
    logo: 'https://gn-imgx.fubo.tv/assets/t448_l_h15_ad.png',
    backgroundColor: '#00468c',
    name: 'New York Islanders',
    league: 'nhl',
  },
  'New York Rangers': {
    id: teamIds['New York Rangers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t449_l_h15_ai.png',
    backgroundColor: '#005dab',
    name: 'New York Rangers',
    league: 'nhl',
  },
  'Ottawa Senators': {
    id: teamIds['Ottawa Senators'],
    logo: 'https://gn-imgx.fubo.tv/assets/t450_l_h15_ad.png',
    backgroundColor: '#745727',
    name: 'Ottawa Senators',
    league: 'nhl',
  },
  'Philadelphia Flyers': {
    id: teamIds['Philadelphia Flyers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t451_l_h15_ad.png',
    backgroundColor: '#f74902',
    name: 'Philadelphia Flyers',
    league: 'nhl',
  },
  'Pittsburgh Penguins': {
    id: teamIds['Pittsburgh Penguins'],
    logo: 'https://gn-imgx.fubo.tv/assets/t453_l_h15_ac.png',
    backgroundColor: '#000000',
    name: 'Pittsburgh Penguins',
    league: 'nhl',
  },
  'San Jose Sharks': {
    id: teamIds['San Jose Sharks'],
    logo: 'https://gn-imgx.fubo.tv/assets/t454_l_h15_aa.png',
    backgroundColor: '#246464',
    name: 'San Jose Sharks',
    league: 'nhl',
  },
  'Seattle Kraken': {
    id: teamIds['Seattle Kraken'],
    logo: 'https://gn-imgx.fubo.tv/assets/t21209_l_h15_ac.png',
    backgroundColor: '#001628',
    name: 'Seattle Kraken',
    league: 'nhl',
  },
  'St. Louis Blues': {
    id: teamIds['St Louis Blues'],
    logo: 'https://gn-imgx.fubo.tv/assets/t455_l_h15_ad.png',
    backgroundColor: '#041e42',
    name: 'St. Louis Blues',
    league: 'nhl',
  },
  'Tampa Bay Lightning': {
    id: teamIds['Tampa Bay Lightning'],
    logo: 'https://imgx.fubo.tv/team_logos/Tampa_Bay_Lightning.png',
    backgroundColor: '#ffffff',
    name: 'Tampa Bay Lightning',
    league: 'nhl',
  },
  'Toronto Maple Leafs': {
    id: teamIds['Toronto Maple Leafs'],
    logo: 'https://gn-imgx.fubo.tv/assets/t457_l_h15_ae.png',
    backgroundColor: '#00205b',
    name: 'Toronto Maple Leafs',
    league: 'nhl',
  },
  'Utah Mammoth': {
    id: teamIds['Utah Mammoth'],
    logo: 'https://gn-imgx.fubo.tv/assets/GNLZZGG001YL7E2.png',
    backgroundColor: '#1B4971',
    name: 'Utah Mammoth',
    league: 'nhl',
  },
  'Vancouver Canucks': {
    id: teamIds['Vancouver Canucks'],
    logo: 'https://gn-imgx.fubo.tv/assets/t458_l_h15_ah.png',
    backgroundColor: '#2A5279',
    name: 'Vancouver Canucks',
    league: 'nhl',
  },
  'Vegas Golden Knights': {
    id: teamIds['Vegas Golden Knights'],
    logo: 'https://gn-imgx.fubo.tv/assets/t14080_l_h15_ac.png',
    backgroundColor: '#333f42',
    name: 'Vegas Golden Knights',
    league: 'nhl',
  },
  'Washington Capitals': {
    id: teamIds['Washington Capitals'],
    logo: 'https://gn-imgx.fubo.tv/assets/t459_l_h15_aa.png',
    backgroundColor: '#041e42',
    name: 'Washington Capitals',
    league: 'nhl',
  },
  'Winnipeg Jets': {
    id: teamIds['Winnipeg Jets'],
    logo: 'https://gn-imgx.fubo.tv/assets/t6053_l_h15_ag.png',
    backgroundColor: '#041e42',
    name: 'Winnipeg Jets',
    league: 'nhl',
  },
  'Atlanta Hawks': {
    id: teamIds['Atlanta Hawks'],
    logo: 'https://gn-imgx.fubo.tv/assets/t400_l_h15_af.png',
    backgroundColor: '#c8102e',
    name: 'Atlanta Hawks',
    league: 'nba',
  },
  'Boston Celtics': {
    id: teamIds['Boston Celtics'],
    logo: 'https://gn-imgx.fubo.tv/assets/t401_l_h15_ab.png',
    backgroundColor: '#007a33',
    name: 'Boston Celtics',
    league: 'nba',
  },
  'Brooklyn Nets': {
    id: teamIds['Brooklyn Nets'],
    logo: 'https://gn-imgx.fubo.tv/assets/t7277_l_h15_ae.png',
    backgroundColor: '#000000',
    name: 'Brooklyn Nets',
    league: 'nba',
  },
  'Charlotte Hornets': {
    id: teamIds['Charlotte Hornets'],
    logo: 'https://imgx.fubo.tv/team_logos/CHornets_Primary.png',
    backgroundColor: '#00788c',
    name: 'Charlotte Hornets',
    league: 'nba',
  },
  'Chicago Bulls': {
    id: teamIds['Chicago Bulls'],
    logo: 'https://gn-imgx.fubo.tv/assets/t403_l_h15_ad.png',
    backgroundColor: '#000000',
    name: 'Chicago Bulls',
    league: 'nba',
  },
  'Cleveland Cavaliers': {
    id: teamIds['Cleveland Cavaliers'],
    logo: 'https://imgx.fubo.tv/team_logos/cleveland-cavaliers.png',
    backgroundColor: '#041e42',
    name: 'Cleveland Cavaliers',
    league: 'nba',
  },
  'Dallas Mavericks': {
    id: teamIds['Dallas Mavericks'],
    logo: 'https://gn-imgx.fubo.tv/assets/t405_l_h15_an.png',
    backgroundColor: '#0053bc',
    name: 'Dallas Mavericks',
    league: 'nba',
  },
  'Denver Nuggets': {
    id: teamIds['Denver Nuggets'],
    logo: 'https://gn-imgx.fubo.tv/assets/t406_l_h15_ae.png',
    backgroundColor: '#0e2240',
    name: 'Denver Nuggets',
    league: 'nba',
  },
  'Detroit Pistons': {
    id: teamIds['Detroit Pistons'],
    logo: 'https://gn-imgx.fubo.tv/assets/t407_l_h15_ac.png',
    backgroundColor: '#1d428a',
    name: 'Detroit Pistons',
    league: 'nba',
  },
  'Golden State Warriors': {
    id: teamIds['Golden State Warriors'],
    logo: 'https://gn-imgx.fubo.tv/assets/t408_l_h15_ac.png',
    backgroundColor: '#1d428a',
    name: 'Golden State Warriors',
    league: 'nba',
  },
  'Houston Rockets': {
    id: teamIds['Houston Rockets'],
    logo: 'https://imgx.fubo.tv/station_logos/houston-rockets_c.png',
    backgroundColor: '#000000',
    name: 'Houston Rockets',
    league: 'nba',
  },
  'Indiana Pacers': {
    id: teamIds['Indiana Pacers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t410_l_h15_ac.png',
    backgroundColor: '#002d62',
    name: 'Indiana Pacers',
    league: 'nba',
  },
  'Los Angeles Clippers': {
    id: teamIds['Los Angeles Clippers'],
    logo: 'https://imgx.fubo.tv/team_logos/clippers.png',
    backgroundColor: '#0a2240',
    name: 'Los Angeles Clippers',
    league: 'nba',
  },
  'Los Angeles Lakers': {
    id: teamIds['Los Angeles Lakers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t412_l_h15_ac.png',
    backgroundColor: '#552583',
    name: 'Los Angeles Lakers',
    league: 'nba',
  },
  'Memphis Grizzlies': {
    id: teamIds['Memphis Grizzlies'],
    logo: 'https://gn-imgx.fubo.tv/assets/t413_l_h15_ac.png',
    backgroundColor: '#5d76a9',
    name: 'Memphis Grizzlies',
    league: 'nba',
  },
  'Miami Heat': {
    id: teamIds['Miami Heat'],
    logo: 'https://gn-imgx.fubo.tv/assets/t414_l_h15_ad.png',
    backgroundColor: '#000000',
    name: 'Miami Heat',
    league: 'nba',
  },
  'Milwaukee Bucks': {
    id: teamIds['Milwaukee Bucks'],
    logo: 'https://gn-imgx.fubo.tv/assets/t415_l_h15_ad.png',
    backgroundColor: '#00471b',
    name: 'Milwaukee Bucks',
    league: 'nba',
  },
  'Minnesota Timberwolves': {
    id: teamIds['Minnesota Timberwolves'],
    logo: 'https://gn-imgx.fubo.tv/assets/t416_l_h15_ac.png',
    backgroundColor: '#236192',
    name: 'Minnesota Timberwolves',
    league: 'nba',
  },
  'New Orleans Pelicans': {
    id: teamIds['New Orleans Pelicans'],
    logo: 'https://gn-imgx.fubo.tv/assets/t7766_l_h15_ac.png',
    backgroundColor: '#002b5c',
    name: 'New Orleans Pelicans',
    league: 'nba',
  },
  'New York Knicks': {
    id: teamIds['New York Knicks'],
    logo: 'https://gn-imgx.fubo.tv/assets/t419_l_h15_ae.png',
    backgroundColor: '#006bb6',
    name: 'New York Knicks',
    league: 'nba',
  },
  'Oklahoma City Thunder': {
    id: teamIds['Oklahoma City Thunder'],
    logo: 'https://gn-imgx.fubo.tv/assets/t426_l_h15_ac.png',
    backgroundColor: '#007ac1',
    name: 'Oklahoma City Thunder',
    league: 'nba',
  },
  'Orlando Magic': {
    id: teamIds['Orlando Magic'],
    logo: 'https://gn-imgx.fubo.tv/assets/t420_l_h15_ad.png',
    backgroundColor: '#0077c0',
    name: 'Orlando Magic',
    league: 'nba',
  },
  'Philadelphia 76ers': {
    id: teamIds['Philadelphia 76ers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t421_l_h15_ac.png',
    backgroundColor: '#9ea5ac',
    name: 'Philadelphia 76ers',
    league: 'nba',
  },
  'Phoenix Suns': {
    id: teamIds['Phoenix Suns'],
    logo: 'https://gn-imgx.fubo.tv/assets/t422_l_h15_ac.png',
    backgroundColor: '#1D1160',
    name: 'Phoenix Suns',
    league: 'nba',
  },
  'Portland Trail Blazers': {
    id: teamIds['Portland Trailblazers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t423_l_h15_ac.png',
    backgroundColor: '#000000',
    name: 'Portland Trail Blazers',
    league: 'nba',
  },
  'Sacramento Kings': {
    id: teamIds['Sacramento Kings'],
    logo: 'https://gn-imgx.fubo.tv/assets/t424_l_h15_ac.png',
    backgroundColor: '#4F2C6D',
    name: 'Sacramento Kings',
    league: 'nba',
  },
  'San Antonio Spurs': {
    id: teamIds['San Antonio Spurs'],
    logo: 'https://gn-imgx.fubo.tv/assets/t425_l_h15_ac.png',
    backgroundColor: '#c4ced4',
    name: 'San Antonio Spurs',
    league: 'nba',
  },
  'Toronto Raptors': {
    id: teamIds['Toronto Raptors'],
    logo: 'https://gn-imgx.fubo.tv/assets/t427_l_h15_ad.png',
    backgroundColor: '#000000',
    name: 'Toronto Raptors',
    league: 'nba',
  },
  'Utah Jazz': {
    id: teamIds['Utah Jazz'],
    logo: 'https://gn-imgx.fubo.tv/assets/t428_l_h15_ae.png',
    backgroundColor: '#061922',
    name: 'Utah Jazz',
    league: 'nba',
  },
  'Washington Wizards': {
    id: teamIds['Washington Wizards'],
    logo: 'https://gn-imgx.fubo.tv/assets/t429_l_h15_ac.png',
    backgroundColor: '#002b5c',
    name: 'Washington Wizards',
    league: 'nba',
  },
  'Arizona Cardinals': {
    id: teamIds['Arizona Cardinals'],
    logo: 'https://gn-imgx.fubo.tv/assets/GNLZZGG001LT5W0.png',
    backgroundColor: '#4F4C4D',
    name: 'Arizona Cardinals',
    league: 'nfl',
  },
  'Atlanta Falcons': {
    id: teamIds['Atlanta Falcons'],
    logo: 'https://gn-imgx.fubo.tv/assets/t32_l_h15_az.png',
    backgroundColor: '#A71930',
    name: 'Atlanta Falcons',
    league: 'nfl',
  },
  'Baltimore Ravens': {
    id: teamIds['Baltimore Ravens'],
    logo: 'https://gn-imgx.fubo.tv/assets/t33_l_h15_ab.png',
    backgroundColor: '#2C2B67',
    name: 'Baltimore Ravens',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Ravens.png',
  },
  'Buffalo Bills': {
    id: teamIds['Buffalo Bills'],
    logo: 'https://gn-imgx.fubo.tv/assets/t34_l_h15_ac.png',
    backgroundColor: '#A40000',
    name: 'Buffalo Bills',
    league: 'nfl',
  },
  'Carolina Panthers': {
    id: teamIds['Carolina Panthers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t35_l_h15_af.png',
    backgroundColor: '#0085ca',
    name: 'Carolina Panthers',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Panthers.png',
  },
  'Chicago Bears': {
    id: teamIds['Chicago Bears'],
    logo: 'https://gn-imgx.fubo.tv/assets/t36_l_h15_ae.png',
    backgroundColor: '#0b162a',
    name: 'Chicago Bears',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Bears.png',
  },
  'Cincinnati Bengals': {
    id: teamIds['Cincinnati Bengals'],
    logo: 'https://gn-imgx.fubo.tv/assets/t37_l_h15_ac.png',
    backgroundColor: '#fb4f14',
    name: 'Cincinnati Bengals',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Bengals.png',
  },
  'Cleveland Browns': {
    id: teamIds['Cleveland Browns'],
    logo: 'https://gn-imgx.fubo.tv/assets/t38_l_h15_ad.png',
    backgroundColor: '#311d00',
    name: 'Cleveland Browns',
    league: 'nfl',
  },
  'Dallas Cowboys': {
    id: teamIds['Dallas Cowboys'],
    logo: 'https://gn-imgx.fubo.tv/assets/t39_l_h15_ab.png',
    backgroundColor: '#002244',
    name: 'Dallas Cowboys',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Cowboys.png',
  },
  'Denver Broncos': {
    id: teamIds['Denver Broncos'],
    logo: 'https://gn-imgx.fubo.tv/assets/t40_l_h15_ac.png',
    backgroundColor: '#002244',
    name: 'Denver Broncos',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Broncos.png',
  },
  'Detroit Lions': {
    id: teamIds['Detroit Lions'],
    logo: 'https://gn-imgx.fubo.tv/assets/t41_l_h15_ab.png',
    backgroundColor: '#0076b6',
    name: 'Detroit Lions',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Lions.png',
  },
  'Green Bay Packers': {
    id: teamIds['Green Bay Packers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t42_l_h15_ac.png',
    backgroundColor: '#203731',
    name: 'Green Bay Packers',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Packers.png',
  },
  'Houston Texans': {
    id: teamIds['Houston Texans'],
    logo: 'https://gn-imgx.fubo.tv/assets/t43_l_h15_ac.png',
    backgroundColor: '#03202f',
    name: 'Houston Texans',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Texans.png',
  },
  'Indianapolis Colts': {
    id: teamIds['Indianapolis Colts'],
    logo: 'https://gn-imgx.fubo.tv/assets/t44_l_h15_ad.png',
    backgroundColor: '#002c5f',
    name: 'Indianapolis Colts',
    league: 'nfl',
  },
  'Jacksonville Jaguars': {
    id: teamIds['Jacksonville Jaguars'],
    logo: 'https://gn-imgx.fubo.tv/assets/t45_l_h15_ac.png',
    backgroundColor: '#006778',
    name: 'Jacksonville Jaguars',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Jaguars.png',
  },
  'Kansas City Chiefs': {
    id: teamIds['Kansas City Chiefs'],
    logo: 'https://gn-imgx.fubo.tv/assets/t46_l_h15_ah.png',
    backgroundColor: '#E31837',
    name: 'Kansas City Chiefs',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Chiefs.png',
  },
  'Las Vegas Raiders': {
    id: teamIds['Las Vegas Raiders'],
    logo: 'https://gn-imgx.fubo.tv/assets/t20783_l_h15_ac.png',
    backgroundColor: '#A5ACAF',
    name: 'Las Vegas Raiders',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Raiders.png',
  },
  'Los Angeles Chargers': {
    id: teamIds['Los Angeles Chargers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t14215_l_h15_ad.png',
    backgroundColor: '#0080C6',
    name: 'Los Angeles Chargers',
    league: 'nfl',
  },
  'Los Angeles Rams': {
    id: teamIds['Los Angeles Rams'],
    logo: 'https://imgx.fubo.tv/team_logos/LARams2020.png',
    backgroundColor: '#223578',
    name: 'Los Angeles Rams',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Rams.png',
  },
  'Miami Dolphins': {
    id: teamIds['Miami Dolphins'],
    logo: 'https://gn-imgx.fubo.tv/assets/t47_l_h15_ad.png',
    backgroundColor: '#265D73',
    name: 'Miami Dolphins',
    league: 'nfl',
  },
  'Minnesota Vikings': {
    id: teamIds['Minnesota Vikings'],
    logo: 'https://gn-imgx.fubo.tv/assets/t48_l_h15_ac.png',
    backgroundColor: '#4F2683',
    name: 'Minnesota Vikings',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Vikings.png',
  },
  'New England Patriots': {
    id: teamIds['New England Patriots'],
    logo: 'https://gn-imgx.fubo.tv/assets/t49_l_h15_ac.png',
    backgroundColor: '#002244',
    name: 'New England Patriots',
    league: 'nfl',
  },
  'New Orleans Saints': {
    id: teamIds['New Orleans Saints'],
    logo: 'https://gn-imgx.fubo.tv/assets/t50_l_h15_ac.png',
    backgroundColor: '#000000',
    name: 'New Orleans Saints',
    league: 'nfl',
  },
  'New York Giants': {
    id: teamIds['New York Giants'],
    logo: 'https://gn-imgx.fubo.tv/assets/t51_l_h15_ac.png',
    backgroundColor: '#05033A',
    name: 'New York Giants',
    league: 'nfl',
  },
  'New York Jets': {
    id: teamIds['New York Jets'],
    logo: 'https://gn-imgx.fubo.tv/assets/t52_l_h15_ae.png',
    backgroundColor: '#125740',
    name: 'New York Jets',
    league: 'nfl',
  },
  'Philadelphia Eagles': {
    id: teamIds['Philadelphia Eagles'],
    logo: 'https://gn-imgx.fubo.tv/assets/t54_l_h15_ac.png',
    backgroundColor: '#004c54',
    name: 'Philadelphia Eagles',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Eagles.png',
  },
  'Pittsburgh Steelers': {
    id: teamIds['Pittsburgh Steelers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t55_l_h15_ac.png',
    backgroundColor: '#000000',
    name: 'Pittsburgh Steelers',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Steelers.png',
  },
  'San Francisco 49ers': {
    id: teamIds['San Francisco 49ers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t57_l_h15_ad.png',
    backgroundColor: '#AA0000',
    name: 'San Francisco 49ers',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/49ers.png',
  },
  'Seattle Seahawks': {
    id: teamIds['Seattle Seahawks'],
    logo: 'https://imgx.fubo.tv/team_logos/Seattle_Seahawks.png',
    backgroundColor: '#69BE28',
    name: 'Seattle Seahawks',
    league: 'nfl',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/NFL/Seahawks.png',
  },
  'Tampa Bay Buccaneers': {
    id: teamIds['Tampa Bay Buccaneers'],
    logo: 'https://gn-imgx.fubo.tv/assets/t60_l_h15_ac.png',
    backgroundColor: '#495053',
    name: 'Tampa Bay Buccaneers',
    league: 'nfl',
  },
  'Tennessee Titans': {
    id: teamIds['Tennessee Titans'],
    logo: 'https://gn-imgx.fubo.tv/assets/t61_l_h15_ac.png',
    backgroundColor: '#4B92DB',
    name: 'Tennessee Titans',
    league: 'nfl',
  },
  'Washington Commanders': {
    id: teamIds['Washington Commanders'],
    logo: 'https://gn-imgx.fubo.tv/assets/t23731_l_h15_ab.png',
    backgroundColor: '#CA7000',
    name: 'Washington Commanders',
    league: 'nfl',
  },
}
